import { Injectable } from '@angular/core';
import { LectureVideoCaption } from '@shared/store';
import { BehaviorSubject } from 'rxjs';

export interface Transcript {
  timestamp: string;
  content: string;
}

@Injectable({
  providedIn: 'root',
})
export class TranscriptService {
  constructor() {}

  // Show hide
  private showTranscript$ = new BehaviorSubject<boolean>(false);
  public isShowTranscript$ = this.showTranscript$.asObservable();

  setShowHide(data: boolean) {
    this.showTranscript$.next(data);
  }

  // Set video position
  private videoPosition$ = new BehaviorSubject<number>(0);
  public getVideoPosition$ = this.videoPosition$.asObservable();
  setVideoPosition(data: number) {
    this.videoPosition$.next(data);
  }

  // Set current position
  private videoSelectedPosition$ = new BehaviorSubject<number>(0);
  public getVideoSelectedPosition$ = this.videoSelectedPosition$.asObservable();
  setVideoSelectedPosition(data: number) {
    this.videoSelectedPosition$.next(data);
  }

  // Selected transcript
  private selectedTranscript$ = new BehaviorSubject<LectureVideoCaption>({
    id: 0,
    label: '',
    srlang: '',
    src: '',
    kind: '',
    default: 0,
    number: 0,
  });
  public getSelectedTranscript$ = this.selectedTranscript$.asObservable();

  setTranscript(data: LectureVideoCaption) {
    this.selectedTranscript$.next(data);
  }
}
